import React, { createContext } from 'react';
import { useLazyQuery, useMutation } from 'react-apollo';

// MUTATIONS

// QUERIES
import GET_ADGROUP_CREATIVES_LIBRARY from '../../../GraphQl/Queries/GET_ADGROUP_CREATIVES_LIBRARY';
import GET_ORG_MEDIAS from '../../../GraphQl/Queries/GET_ORG_MEDIAS';
import CREATE_ADGROUP_CREATIVES from '../../../GraphQl/Mutations/CREATE_ADGROUP_CREATIVES';

const CreativeContext = createContext({});

export const CreativeProvider = (props) => {
  const { children } = props;

  const [fetchAdGroupCreatives, { data: dataAdGroupCreatives, loading: loadingAdGroupCreatives }] =
    useLazyQuery(GET_ADGROUP_CREATIVES_LIBRARY, {});

  const [fetchVideoMedias, { data: dataVideoMedias, loading: loadingVideoMedias }] = useLazyQuery(
    GET_ORG_MEDIAS,
    {}
  );

  const [createAdGroupCreatives] = useMutation(CREATE_ADGROUP_CREATIVES);

  return (
    <CreativeContext.Provider
      value={{
        fetchAdGroupCreatives,
        adGroupCreatives: (dataAdGroupCreatives && dataAdGroupCreatives.adGroupCreativeses) || [],
        loadingAdGroupCreatives,
        // Videos support
        fetchVideoMedias,
        videoMedias: (dataVideoMedias && dataVideoMedias.medias) || [],
        loadingVideoMedias,
        createAdGroupCreatives,
      }}
      {...props}
    >
      {children}
    </CreativeContext.Provider>
  );
};

export default CreativeContext;
